import { useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { Nav, NavItem, NavLink } from "reactstrap";
import ProjAdminItemsListV2 from "./ProjAdminItemsListV2";
import DivisionOfWorkTab from "./DivisionOfWorkTab";

// Project role symbols allowed to see Division of Work tab:
// RE, SR (Senior RE), CE/BCE (Senior RE), OE. Office/System admins are
// handled separately below since they may not have a projectRoles entry.
const DOW_ALLOWED_ROLES = ["RE", "SR", "CE", "CERE", "BCE", "BCESR", "OE"];

export default function ProjAdminItems({ tabId, permissions, projectId, isReadOnly }) {
  const [activeTab, setActiveTab] = useState("itemList");

  const user = useSelector((state) => state.authentication.user);

  const canSeeDivisionOfWork = useMemo(() => {
    if (user?.isOfficeAdmin || user?.isSystemAdmin) return true;
    if (!user?.projectRoles) return false;
    const projectRole = user.projectRoles.find((pr) => pr.projectId === projectId);
    return projectRole && DOW_ALLOWED_ROLES.includes(projectRole.projectRoleSymbol);
  }, [user, projectId]);

  return (
    <div className="pt-2">
      <Nav tabs className="mb-2">
        <NavItem>
          <NavLink
            className={activeTab === "itemList" ? "active" : ""}
            onClick={() => setActiveTab("itemList")}
            style={{ cursor: "pointer" }}
          >
            Item List
          </NavLink>
        </NavItem>
        {canSeeDivisionOfWork && (
          <NavItem>
            <NavLink
              className={activeTab === "divisionOfWork" ? "active" : ""}
              onClick={() => setActiveTab("divisionOfWork")}
              style={{ cursor: "pointer" }}
            >
              Division of Work
            </NavLink>
          </NavItem>
        )}
      </Nav>

      {activeTab === "itemList" && (
        <ProjAdminItemsListV2
          tabId={tabId}
          projectId={projectId}
          permissions={permissions}
          isReadOnly={isReadOnly}
        />
      )}

      {activeTab === "divisionOfWork" && canSeeDivisionOfWork && (
        <DivisionOfWorkTab projectId={projectId} permissions={permissions} />
      )}
    </div>
  );
}
